import VResponsive from './VResponsive';
export { VResponsive };
export default VResponsive;
//# sourceMappingURL=index.js.map